module.exports = __webpack_public_path__ + "img/bb5037e414cb27b0e7d0f7ea87391da1.acaf9573.jpg";